import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "./user/loginReducer";
import paginationFilterSlice from "./Pagination/filtersReducer";
import leadsFilteredSlice from "./Filtered leads/filteredLeadReducer";
import followupLeadsSlice from "./Filtered leads/followupLeadReducer";
import enquiriesSlice from "./Filtered leads/enquiriesReducer";
import buyerFilterSlice from "./Buyer/buyerFiltersReducer";
import myOperatorSlice from "./Filtered leads/myOperatorRedux";
import nhmApplicantsFilterSlice from "./Pagination/nhmApplicants";
import taskFilteredSlice from "./Task/taskFilterReducer";
import taskReducer from "./Task/taskReducer";
import employeeReducer from "./employeeManagement/employeeReducer";
import postingScheduleSlice from "./Media & Marketing/postingScheduleRedux";
import paginationSlice from "./Pagination/pagination";
import leadsCloserSlice from "./Filtered leads/leadCloserReducer";
import newenquirySlice from "./Filtered leads/newenquiriesReducer";
import payroleSlice from "./Payrole/payroleReducer";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    filters: paginationFilterSlice,
    leadFilteredfilters: leadsFilteredSlice,
    followupLeadsFilters: followupLeadsSlice,
    myOperatorFilters: myOperatorSlice,
    enquiriesFilters: enquiriesSlice,
    buyerFilters: buyerFilterSlice,
    nhmFilters: nhmApplicantsFilterSlice,
    taskFilters: taskFilteredSlice,
    task: taskReducer,
    employeeReducer: employeeReducer,
    postingScheduleReducer: postingScheduleSlice,
    pagination: paginationSlice,
    leadsCloserReducer: leadsCloserSlice,
    newenquiryReducer: newenquirySlice,
    payroleReducer: payroleSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
